import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { ACKNOWLEDGE_UPLOADED_DOCUMENT, ACKNOWLEDGE_UPLOADED_DOCUMENT_ERROR, ACKNOWLEDGE_UPLOADED_DOCUMENT_SUCCESS } from '../../../actionType.js';

function* acknowledgeUploadedDocument({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/program/${payload?.params?.id}/presigned`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: ACKNOWLEDGE_UPLOADED_DOCUMENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: ACKNOWLEDGE_UPLOADED_DOCUMENT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: ACKNOWLEDGE_UPLOADED_DOCUMENT_ERROR, payload: error });
  }
}

export function* watchAcknowledgeUploadedDocument() {
  yield takeEvery(ACKNOWLEDGE_UPLOADED_DOCUMENT, acknowledgeUploadedDocument);
}

function* getAcknowledgeUploadedDocumentSaga() {
  yield all([fork(watchAcknowledgeUploadedDocument)]);
}

export default getAcknowledgeUploadedDocumentSaga;
